import EventStreamsWidget from './EventStreamsWidget';

export default EventStreamsWidget;
